export default "__VITE_ASSET__DE8szS6s__"